import styled from 'styled-components';

export const GarageCardWrapper = styled.div`
    display: flex;
    min-height: 592px;
    padding: 12px 12px 32px 12px;
    flex-direction: column;
    gap: 24px;
    background: #fff;
`;

export const GarageCardContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;
`;

export const GarageCardHeading = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;
`;

export const GarageCardHeadingRow = styled.p`
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
`;

export const GarageCardTextContent = styled.div`
    flex: 1 0 0;
    color: #121212
    font-size: 20px;
    font-weight: 600;
    line-height: 28px; 
    letter-spacing: -0.1px;
`;

export const GarageDetailsContainer = styled.div`
    display: flex;
    min-height: 512px;
    flex-direction: column;
    align-items: flex-start;
    flex-shrink: 0;
    border-radius: 16px;
    border: 1px solid #e8e8e8;
    background: #fff;
`;

export const GarageDetailsVideoContainer = styled.div`
    min-height: 180px;
    width: 100%;
    flex-shrink: 0;
    align-self: stretch;
    aspect-ratio: 16/9;
    background: #fff;
    position: relative;
    overflow: hidden;
    border-radius: 16px 16px 0 0;
`;

export const CarouselTrack = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    gap: 0;
    overflow-x: auto;
    overflow-y: hidden;
    border-radius: 16px 16px 0 0;
    scroll-snap-type: x mandatory;
    isolation: isolate;

    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
`;

export const CarouselItem = styled.div<{ $width?: number }>`
    width: ${(props) => props.$width || 360}px;
    min-height: 180px;
    flex-shrink: 0;
    position: relative;
    scroll-snap-align: start;
    scroll-snap-stop: always;
    cursor: pointer;
    overflow: hidden;

    & > * {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    & > div:first-child {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
`;

export const GarageServiceableAreasContainer = styled.div`
    display: flex;
    width: 100%;
    min-height: 23px;
    padding-top: 4px;
    flex-direction: column;
    align-items: center;
    gap: 0;
    flex-shrink: 0;
    background: linear-gradient(
        90deg,
        #121314 0.48%,
        #2d2d2d 34.13%,
        #373737 61.06%,
        #121314 96.63%
    );
    overflow: hidden;
    position: relative;
`;

export const GarageServiceableAreasContainerWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    overflow: hidden;
    position: relative;
`;

export const GarageServiceableAreaTextWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    white-space: nowrap;
    animation: scrollLinear 25s linear infinite;
    will-change: transform;

    @keyframes scrollLinear {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(calc(-100% / 3));
        }
    }

    &:hover {
        animation-play-state: paused;
    }
`;

export const GarageServiceableAreaText = styled.div`
    color: #fff;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
`;

export const PlayButtonOverlay = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    transition: opacity 0.3s ease;
`;

export const GarageInfoContainer = styled.div`
    display: flex;
    padding: 20px 12px 12px 12px;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
    align-self: stretch;
`;

export const GarageInfoDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
`;

export const GarageInfoHeadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
`;

export const GarageInfoHeadingTextWrapper = styled.div`
    display: flex;
    padding: 4px 8px;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: #f5f5f5;
    backdrop-filter: blur(6px);
`;

export const StarIconWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
`;

export const SplitIconContainer = styled.div`
    display: flex;
    align-items: center;
    margin: 0 8px;
    height: 16px;
    stroke-width: 1px;
    stroke: #e8e8e8;
`;

export const GarageInfoHeadingText = styled.div`
    display: flex;
    align-items: center;
    color: #121212;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    gap: 0;
`;

export const GarageInfoDescriptionContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
`;

export const GarageInfoDescription = styled.div`
    color: #121212;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
`;

export const GarageTimingContainer = styled.div`
    display: flex;
    padding: 4px 8px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    background: linear-gradient(90deg, #f5f5f5 0%, #fff 100%);
`;

export const GarageTimingHeading = styled.div`
    align-self: stretch;
    color: #4b4b4b;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
`;

export const GarageMapContainer = styled.div`
    display: flex;
    height: 200px;
    align-items: center;
    border-radius: 12px;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    align-self: stretch;
    margin-top: 12px;
    background: #f5f5f5;

    &:hover {
        opacity: 0.9;
    }

    &:active {
        opacity: 0.8;
    }
`;

export const GarageMapIframe = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 12px;
    pointer-events: auto;
`;

export const GarageMapOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 150px;
    height: 40px;
    z-index: 10;
    cursor: pointer;
    background: transparent;
    border-radius: 0 0 12px 0;
    pointer-events: auto;

    &:hover {
        background: rgba(255, 255, 255, 0.05);
    }

    &:active {
        background: rgba(255, 255, 255, 0.1);
    }
`;

export const GarageMapInfoContainer = styled.div`
    display: flex;
    width: 100%;
    min-height: 40px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 0 0 12px 12px;
    background: #f5f5f5;
    align-self: stretch;
    margin-top: -15px;
`;

export const GarageMapInfoText = styled.span`
    color: #121212;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    text-align: center;
`;

export const GarageSlotDetailContainer = styled.div`
    display: flex;
    min-width: 296px;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background: #efe9fb;
    gap: 8px;
`;

export const GarageSlotDetailText = styled.p`
    color: #5920c5;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
`;

export const GarageButtonContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    align-self: stretch;
`;

interface RecommendedTagContainerProps {
    $isRecommended?: boolean;
}

export const RecommendedTagContainer = styled.div<RecommendedTagContainerProps>`
    display: flex;
    max-width: ${(props) => (props.$isRecommended ? '120px' : '150px')};
    max-height: 28px;
    padding: 4px 8px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 12px 0;
    background: ${(props) =>
        props.$isRecommended ? '#844fe9' : 'rgba(18, 18, 18, 0.31)'};
    backdrop-filter: blur(2px);
    position: absolute;
    top: -1;
    left: 0;
    z-index: 20;
    pointer-events: none;
    flex-shrink: 0;
    box-sizing: border-box;
`;

export const RecommendedTagWrapper = styled.div`
    display: flex;
    height: 14px;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
`;

export const RecommendedIconWrapper = styled.div`
    display: flex;
    min-width: 12px;
    height: 12px;
    padding: 0.72px 2.19px 0.5px 2.19px;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1/1;
`;

export const RecommendedTagText = styled.span`
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
`;

// Lightbox Styles - Matching react-image-lightbox design
export const LightboxOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.9);
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;

export const LightboxContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    pointer-events: auto;
`;

export const LightboxContent = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;

    img,
    video {
        max-width: 100%;
        max-height: 100vh;
        margin: auto;
    }

    img {
        width: auto;
        height: auto;
        object-fit: contain;
    }

    video {
        object-fit: cover;
    }

    & > div {
        width: 100%;
        height: 100%;
        max-width: 100vw;
        max-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const LightboxImage = styled.img`
    max-width: 100%;
    max-height: 100vh;
    width: auto;
    height: auto;
    object-fit: contain;
    margin: auto;
    display: block;
`;

export const LightboxCloseButton = styled.button`
    position: fixed;
    top: 10px;
    right: 10px;
    background: rgba(0, 0, 0, 0.5);
    border: none;
    border-radius: 4px;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2001;
    transition: background 0.2s ease;
    padding: 0;
    outline: none;

    &:hover {
        background: rgba(0, 0, 0, 0.7);
    }

    &:active {
        background: rgba(0, 0, 0, 0.8);
    }

    svg {
        width: 20px;
        height: 20px;
        fill: white;
        stroke: white;
    }

    @media (max-width: 768px) {
        top: 5px;
        right: 5px;
        width: 36px;
        height: 36px;

        svg {
            width: 18px;
            height: 18px;
        }
    }
`;

interface LightboxNavButtonProps {
    $position: 'left' | 'right';
}

export const LightboxNavButton = styled.button<LightboxNavButtonProps>`
    position: fixed;
    top: 50%;
    ${(props) => (props.$position === 'left' ? 'left: 10px;' : 'right: 10px;')}
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.5);
    border: none;
    border-radius: 4px;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2001;
    transition: background 0.2s ease;
    padding: 0;
    outline: none;

    &:hover {
        background: rgba(0, 0, 0, 0.7);
    }

    &:active {
        background: rgba(0, 0, 0, 0.8);
    }

    svg {
        width: 20px;
        height: 20px;
        fill: white;
        stroke: white;
    }

    @media (max-width: 768px) {
        ${(props) =>
            props.$position === 'left' ? 'left: 5px;' : 'right: 5px;'}
        width: 36px;
        height: 36px;

        svg {
            width: 18px;
            height: 18px;
        }
    }
`;

export const DotsContainerWrapper = styled.div`
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 79.69%, #000 99.8%);
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    border-radius: 16px 16px 0 0;
    & > div {
        pointer-events: auto;
    }
`;

export const DotsContainer = styled.div`
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    z-index: 10;
`;

export const Dot = styled.span`
    height: 6px;
    width: 6px;
    margin: 0 5px;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
    &.active {
        background-color: rgba(255, 255, 255, 0.5);
        width: 12px;
        border-radius: 30px;
    }
`;
